import { useState, useEffect } from 'react';

const contentCache: Record<string, any> = {};

export function useContent<T = any>(page: string, fallback: T): T {
  const [content, setContent] = useState<T>(() => contentCache[page] || fallback);

  useEffect(() => {
    if (contentCache[page]) {
      setContent(contentCache[page]);
      return;
    }

    fetch(`/api/content/${page}`)
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        if (data && Object.keys(data).length > 0) {
          contentCache[page] = data;
          setContent(data);
        }
      })
      .catch(() => {
        // Use fallback on error
      });
  }, [page]);

  return content;
}

export function invalidateContent(page: string) {
  delete contentCache[page];
}
